exports.EntryHeader = require("./entryHeader");
exports.MainHeader = require("./mainHeader");